// frontend/src/pages/ShopProducts.js
import { PhotoProvider, PhotoView } from "react-photo-view";
import "react-photo-view/dist/react-photo-view.css";
import React, { useEffect, useState } from "react";
import axiosInstance from "../api/axiosInstance";
import { useNavigate } from "react-router-dom";
import "./ShopProducts.css";
import LoadingAnimation from "../components/LoadingAnimation";
import CartButton from "../components/CartButton";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";



export default function ShopProducts() {
  const navigate = useNavigate();
const [adminPhone, setAdminPhone] = useState("");
  const [products, setProducts] = useState([]);
  const [search, setSearch] = useState("");
  const [pharmacistMsg, setPharmacistMsg] = useState("");

  const [cartQty, setCartQty] = useState({});
  const [cartItemId, setCartItemId] = useState({});
  const [cartCount, setCartCount] = useState(0);

  const [loading, setLoading] = useState(false);

  // 🔥 PER PRODUCT LOADING
  const [updatingId, setUpdatingId] = useState(null);

  const role = localStorage.getItem("userRole");

  // ---------------- LOAD ----------------

  useEffect(() => {
    
    loadCart();
  }, []);
useEffect(() => {

  const delay = setTimeout(() => {

    loadProducts();

  }, 300);

  return () => clearTimeout(delay);

}, [search]);

  async function loadProducts() {
    setLoading(true);

    try {
      const res = await axiosInstance.get(`/surgical/list/?search=${search}`);
      setProducts(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      console.log("Load products error:", err);
      alert("Failed to load medicines");
    } finally {
      setLoading(false);
    }
  }

  async function loadCart() {
    try {
      const res = await axiosInstance.get("/cart/");
      const items = res.data.items || [];

      const qtyMap = {};
      const idMap = {};

      items.forEach((it) => {
        const pid = `surgical_${it.product_id || it.product?.id}`;

if (it.cart_type === "surgical") {

  qtyMap[pid] = it.quantity;
  idMap[pid] = it.id;

}
      });

      setCartQty(qtyMap);
      setCartItemId(idMap);

      const total = Object.values(qtyMap).reduce((a, b) => a + b, 0);
      setCartCount(total);

    } catch (err) {
      console.log("Cart error:", err);
      setCartQty({});
      setCartItemId({});
      setCartCount(0);
    }
  }

  function wait(ms) {
    return new Promise((res) => setTimeout(res, ms));
  }

  // ---------------- ADD ----------------

  async function addToCart(productId, quantity = 1) {
    if (updatingId === productId) return;

    setUpdatingId(productId);

    try {
      await axiosInstance.post("/surgical-cart/add/", {
        product_id: productId,
        quantity,
      });

      await wait(150);
      await loadCart();

    } catch (err) {
      console.log("Add error:", err?.response?.data || err);
      alert("Failed to add");
    } finally {
      setUpdatingId(null);
    }
  }




useEffect(() => {
  

  axiosInstance.get("/admin/emergency-contact/get/")
    .then(res => {
     // console.log("Emergency contact data:", res.data); // 👈 yahan
      setAdminPhone(res.data.phone);
    })
    .catch(() => setAdminPhone(""));
}, []);
  // ---------------- INCREASE ----------------

  async function increaseQty(productId) {
    if (updatingId === productId) return;

    setUpdatingId(productId);

    const itemId = cartItemId[`surgical_${productId}`];

    if (!itemId) {
      await addToCart(productId, 1);
      setUpdatingId(null);
      return;
    }

    try {
      await axiosInstance.post("/surgical-cart/update/", {
  item_id: itemId,
  action: "increase",
});
      await wait(150);
      await loadCart();

    } catch (err) {
      console.log("Increase error:", err);
      alert("Increase failed");
    } finally {
      setUpdatingId(null);
    }
  }

  // ---------------- DECREASE ----------------

  async function decreaseQty(productId) {
    if (updatingId === productId) return;

    setUpdatingId(productId);

    const itemId = cartItemId[`surgical_${productId}`];

    if (!itemId) {
      setUpdatingId(null);
      return;
    }

    try {
      if ((cartQty[`surgical_${productId}`] || 0) <= 1) {
        await axiosInstance.post("/surgical-cart/remove/", {
  item_id: itemId,
});
      } else {
        await axiosInstance.post("/surgical-cart/update/", {
  item_id: itemId,
  action: "decrease",
});
      }

      await wait(150);
      await loadCart();

    } catch (err) {
      console.log("Decrease error:", err);
      alert("Decrease failed");
    } finally {
      setUpdatingId(null);
    }
  }

  // ---------------- MESSAGE ----------------

  async function sendPharmacistMessage() {
    if (!pharmacistMsg.trim()) return;

    try {
      await axiosInstance.post("/request_medicine/", {
        text: pharmacistMsg,
      });

      alert("Sent!");
      setPharmacistMsg("");

    } catch (err) {
      alert("Send failed");
    }
  }

  // ---------------- HELPERS ----------------

  const filteredProducts = products;

 

  // ---------------- UI ----------------
if (loading && products.length === 0) {
  return <LoadingAnimation />;
}
  return (
 
    <div className="shop-container">

      {/* HEADER */}



  
  <CartButton />

      {/* SEARCH */}
  <div style={styles.searchWrapper}>

      <input

        value={search}

        onChange={(e) => setSearch(e.target.value)}

        placeholder="Search Surgical Items..."

        style={styles.searchInput}

      />

    </div>

      {/* GRID */}

     <div className="product-grid">

        {filteredProducts.map((p) => {

          const qty = cartQty[`surgical_${p.id}`] || 0;
          const isUpdating = updatingId === p.id;

          const price = p.selling_price || p.price || 0;
          const mrp = p.mrp || p.price || 0;

          const discount =
            mrp && price ? Math.round(((mrp - price) / mrp) * 100) : 0;

          return (

            <div
  key={p.id}
  style={{
    border: "1px solid #eee",
    padding: 14,
    borderRadius: 10,

    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",

    minHeight: 520,   // IMPORTANT
    background: "#fff"
  }}
>

              <div style={{ textAlign: "center", marginBottom: 6 }}>
{loading && products.length > 0 && (
  <div style={{ textAlign: "center", padding: 10 }}>
    <LoadingAnimation small />
  </div>
)}
  {/* MEDICINE NAME */}

  <div style={{
    fontWeight: 700,
    fontSize: 15,
    color: "#222",
    marginBottom: 4,
    minHeight: 38
  }}>
    {p.name}
  </div>


  {/* SALT BADGE */}

  {p.salt_composition && (

    <div style={{
      display: "inline-block",
      background: "#eef2ff",
      color: "#3730a3",
      padding: "3px 8px",
      borderRadius: 6,
      fontSize: 12,
      fontWeight: 500,
      marginBottom: 3
    }}>

      🧪 {p.salt_composition}

    </div>

  )}


  {/* COMPANY */}

  {p.company && (

    <div style={{
      fontSize: 12,
      color: "#666",
      marginTop: 2
    }}>

      by <span style={{
        fontWeight: 600,
        color: "#111"
      }}>
        {p.company}
      </span>

    </div>

  )}

</div>

             <div
  style={{
    height: 180,
    width: "100%",
    textAlign: "center",
    overflow: "hidden",
    position: "relative",
  }}
>

  {p.images && p.images.length > 0 ? (
<PhotoProvider maskClosable={true}>
    <Swiper
      spaceBetween={0}
      slidesPerView={1}
      pagination={{ clickable: true }}
      modules={[Pagination]}
      touchStartPreventDefault={false}
      style={{
        width: "100%",
        height: "100%",
      }}
    >

      {p.images.map((img, index) => (

        <SwiperSlide key={index}>

          <div
            style={{
              width: "100%",
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              overflow: "hidden",
            }}
          >

            <PhotoView src={img}>

              <img
                src={img}
                alt={p.name}
                loading="lazy"
                onError={(e) => {
                  e.target.src = "/no-image.png";
                }}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "contain",
                  cursor: "zoom-in",
                }}
              />

            </PhotoView>

          </div>

        </SwiperSlide>

      ))}

    </Swiper>
</PhotoProvider>

  ) : p.image ? (
<PhotoProvider maskClosable={true}>
    <PhotoView src={p.image || "/no-image.png"}>

      <img
        src={p.image || "/no-image.png"}
        loading="lazy"
        onError={(e) => {
          e.target.src = "/no-image.png";
        }}
        style={{
          width: "100%",
          height: "100%",
          objectFit: "contain",
          cursor: "zoom-in",
        }}
        alt={p.name}
      />

    </PhotoView>
</PhotoProvider>
  ) : (

    <div
      style={{
        background: "#f5f5f5",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        color: "#888",
      }}
    >
      No Image
    </div>

  )}

</div>

<div
  style={{
    fontSize: 11,
    color: "#777",
    textAlign: "center",
    marginTop: 4,
  }}
>
   Tap image to zoom • Tap outside to close
</div>

    
              <div style={{ textAlign: "center", marginTop: 6 }}>

                <del style={{ color: "red" }}>{mrp ? `₹${mrp}` : ""}</del>
{p.stock === 0 && (

  <div style={{
    color: "red",
    fontWeight: 600,
    marginTop: 4,
    fontSize: 13
  }}>

    Out of Stock

  </div>

)}

                <div style={{ color: "green", fontSize: 18 }}>₹{price}</div>

                {discount > 0 && (
                  <div style={{ color: "orange" }}>{discount}% OFF</div>
                )}

              </div>

              {/* CART */}

              <div style={{ marginTop: 10 }}>

                {qty > 0 ? (

                  <div style={{ textAlign: "center" }}>

                    <div style={{ display: "flex", justifyContent: "center", gap: 10 }}>

                      <button onClick={() => decreaseQty(p.id)} disabled={isUpdating}>
                        −
                      </button>

                      <div>{qty}</div>

                      <button onClick={() => increaseQty(p.id)} disabled={isUpdating}>
                        +
                      </button>

                    </div>

                    <button
                      onClick={() => addToCart(p.id, 1)}
                      disabled={isUpdating}
                      style={{
                        width: "100%",
                        marginTop: 10,
                        background: "#0284C7",
                        color: "#fff",
                        padding: 8,
                        borderRadius: 6,
                        border: "none",
                      }}
                    >
                      {isUpdating ? <LoadingAnimation small /> : "Add More"}
                    </button>

                  </div>

                ) : (

                  <button
  onClick={() => p.stock > 0 && addToCart(p.id, 1)}
  disabled={p.stock === 0 || isUpdating}
  style={{
    width: "100%",
    marginTop: 10,
    background: p.stock === 0 ? "#ddd" : "green",
    color: p.stock === 0 ? "#666" : "#fff",
    padding: 10,
    borderRadius: 6,
    border: "none",
    fontWeight: 600
  }}
>
  {isUpdating ? (
  <LoadingAnimation small />
) : p.stock === 0 ? (
  "Out of Stock"
) : (
  "Add to Cart"
)}
</button>

                )}

              </div>

            </div>
          );
        })}

      </div>

{/* MOBILE STICKY CART */}


    </div>
 
  );
}
const styles = {
searchWrapper: {

  maxWidth: 500,

  margin: "20px auto",

},



searchInput: {

  width: "100%",

  padding: 12,

  borderRadius: 10,

  border: "1px solid #ddd",

},
};
